
import { Node, Edge } from '@xyflow/react';

// Initial nodes for the flow editor
export const initialNodes: Node[] = [
  {
    id: 'policy-1',
    type: 'policyDetails',
    position: { x: 50, y: 50 },
    data: { 
      label: 'Policy Configuration', 
      policyName: 'External Sharing Restrictions', 
      description: 'Limits external sharing to specific domains and requires review', 
      category: 'security',
      isActive: true
    },
  },
  {
    id: 'sharepoint-1',
    type: 'sharepoint',
    position: { x: 50, y: 200 },
    data: { 
      label: 'SharePoint Teams', 
      listName: 'teamPolicies',
      operation: 'read',
      filter: ''
    },
  },
  {
    id: 'condition-1',
    type: 'condition',
    position: { x: 50, y: 350 },
    data: { 
      label: 'Check External Sharing', 
      field: 'ExternalSharingEnabled',
      operator: 'equals',
      value: 'true'
    },
  },
  {
    id: 'action-1',
    type: 'action',
    position: { x: 50, y: 500 },
    data: { 
      label: 'Send Notification', 
      actionType: 'notification',
      target: 'team.owners',
      message: 'External sharing is enabled on your team. Please review settings.'
    },
  },
];

// Initial edges for the flow editor
export const initialEdges: Edge[] = [
  { 
    id: 'e1-2', 
    source: 'policy-1', 
    target: 'sharepoint-1', 
    animated: true,
    type: 'smoothstep',
  },
  { 
    id: 'e2-3', 
    source: 'sharepoint-1', 
    target: 'condition-1', 
    animated: true,
    type: 'smoothstep',
  },
  { 
    id: 'e3-4', 
    source: 'condition-1', 
    target: 'action-1', 
    animated: true,
    type: 'smoothstep',
  },
];
